import React from 'react'

const SOURCE_META = {
  plans:     { label: 'Plans',     colorClass: 'src-chip--info' },
  quote:     { label: 'Quote',     colorClass: 'src-chip--accent' },
  aspire:    { label: 'Aspire',    colorClass: 'src-chip--ok' },
  catalog:   { label: 'Catalog',   colorClass: 'src-chip--primary' },
  vendor:    { label: 'Vendor',    colorClass: 'src-chip--warn' },
  legacy:    { label: 'Legacy',    colorClass: 'src-chip--muted' },
  aggregate: { label: 'Aggregate', colorClass: 'src-chip--accent' },
}

export const SourceChip = ({ kind, label, size }) => {
  const meta = SOURCE_META[kind] || SOURCE_META.legacy
  return (
    <span className={`src-chip ${meta.colorClass}${size === 'xs' ? ' src-chip--xs' : ''}`}>
      {label || meta.label}
    </span>
  )
}

export const SourceCluster = ({ sources }) => {
  if (!sources || sources.length === 0) return null
  return (
    <div className="src-cluster">
      {sources.map((s, i) => <SourceChip key={i} kind={s.kind} label={s.label} />)}
    </div>
  )
}

export { SOURCE_META }
export default SourceChip
